'use strict';

module.exports = function getUserAgent() {
  return global.navigator.userAgent;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web/client/request/get-user-agent.js
// module id = 166
// module chunks = 0